import { useCallback, useState } from "react";
import { ChannelkartNetworkPatch, ChannelkartNetworkPost } from "../../../../services/networkService";
import { labelMappings } from "../../utils/utils";
import { openPopup } from "../../../../stateManagement/actions/popupActions";
import { updateBannerActive, uploadBannerImage, uploadBannerPriority } from "../../../../stateManagement/actions/manageCouponActions";
import { useSelector } from "react-redux";
import { CouponEditType } from "../../types";

const MAX_IMAGE_WIDTH = 500;
const MAX_IMAGE_HEIGHT = 416;

export async function uploadDocument(formData: FormData) {
    try{
        
        let url = "/v1/uploadMultipleFiles/images";
        const response = await ChannelkartNetworkPost(url, formData,{"Content-Type": "multipart/form-data"})
        const blobUrls = [];
        for(let urlNum=0;urlNum<response.data.length;urlNum++){
            const body = JSON.parse(response.data[urlNum].body);
            blobUrls.push(body?.features?.[0]?.Uri);
        }
        return blobUrls;
    }catch(err){
        throw new Error("Something went wrong, Try again");
    }
}


export const handlePublishClickOnViewAndEdit = (setOpenPublishConfirmModal:React.Dispatch<React.SetStateAction<boolean>>,setModalMessage:React.Dispatch<React.SetStateAction<string>>) => {
    // if (dateChanged == false) {
    //     openPopup("Alert", labelMappings["NO_CHANGES_MSG"])
    // }
    // if (dateChanged == true) {
        setOpenPublishConfirmModal(true);
        setModalMessage(labelMappings["CONFIRM_PUBLISH"])
    // }
}

export const handlePublishClickOnClone = (setOpenPublishConfirmModal:React.Dispatch<React.SetStateAction<boolean>>,setModalMessage:React.Dispatch<React.SetStateAction<string>>) => {
    setOpenPublishConfirmModal(true);
    setModalMessage(labelMappings["CONFIRM_PUBLISH"])
}


export const handlePublishSchemePlayground = (setOpenPublishConfirmModal:React.Dispatch<React.SetStateAction<boolean>>,setModalMessage:React.Dispatch<React.SetStateAction<string>>) => {
    setOpenPublishConfirmModal(true);
    setModalMessage(labelMappings["PUBLISH_IN_PLAYGROUND"])
}



export const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>,setFileUploaded:React.Dispatch<React.SetStateAction<Blob | undefined>>,setSelectedFile:React.Dispatch<React.SetStateAction<string>>,setImageIcon:React.Dispatch<React.SetStateAction<string>>,fileInputRef:React.MutableRefObject<HTMLInputElement>) => {
        const fileUploaded = event.target.files?.[0];
        if (fileUploaded) {
            const image = new Image();
            image.src = URL.createObjectURL(fileUploaded);

            image.onload = () => {
                const imageWidth = image.naturalWidth;
                const imageHeight = image.naturalHeight;

                if (imageWidth !== MAX_IMAGE_WIDTH || imageHeight !== MAX_IMAGE_HEIGHT) {
                    openPopup('Alert', `Image dimensions do not match the resolution ${MAX_IMAGE_WIDTH}x${MAX_IMAGE_HEIGHT}`);
                    setFileUploaded(undefined);
                    setSelectedFile("");
                    setImageIcon("");
                    if (fileInputRef.current) {
                        fileInputRef.current.value = "";
                    }
                }else {
                    setFileUploaded(fileUploaded);
                    setSelectedFile(fileUploaded.name);
                    setImageIcon(URL.createObjectURL(fileUploaded));
                }
            }
        }
};

export const handleBannerSwitch = (event: React.ChangeEvent<HTMLInputElement>) => {
    updateBannerActive(event.target.checked)
}

export const handlePriorityChange = (event: any,setPriority:React.Dispatch<React.SetStateAction<number>>) => {
    let newPriority = event.target.value;
    setPriority(newPriority);
    uploadBannerPriority(newPriority);
};

export const handleCloseButton = (event: any,fileInputRef:React.MutableRefObject<HTMLInputElement>,setFileUploaded:React.Dispatch<React.SetStateAction<Blob | undefined>>,setSelectedFile:React.Dispatch<React.SetStateAction<string>>,setPriority:React.Dispatch<React.SetStateAction<number>>) => {
    event.stopPropagation()
    setFileUploaded(undefined);
    setSelectedFile("");
    setPriority(1);
    uploadBannerImage("")
    uploadBannerPriority("1")
    if (fileInputRef.current) {
        fileInputRef.current.value = "";
    }
}

export const getPriorityLabel = (number: any) => {
    if (number <= 5) {
        return "Low";
    } else if (number <= 10) {
        return "Medium";
    } else if (number <= 15) {
        return "High";
    } else {
        return "Highest";
    }
};

export const handlePublishCloneClick = async (deleteParent:boolean,couponId:string,handlePublishClick: () => Promise<void>) => {
    try {
        if (deleteParent) {
            await ChannelkartNetworkPatch('/v1/schemes/update?activeStatus=inactive&schemeId=' + couponId);
        }
        await handlePublishClick();
    } catch (error) {
        console.error('Error fetching data:', error);
    }
}

export const handlePublish = async(isSchemePlayground:boolean,couponEditType:CouponEditType,setOpenPublishConfirmModal:React.Dispatch<React.SetStateAction<boolean>>,setModalMessage:React.Dispatch<React.SetStateAction<string>>,handlePublishClick: () => Promise<void>) => {
    if (isSchemePlayground) {
        handlePublishSchemePlayground(setOpenPublishConfirmModal,setModalMessage);
        return;
    }
    if (couponEditType === "edit") {
        handlePublishClickOnViewAndEdit(setOpenPublishConfirmModal,setModalMessage);
    }
    else if (couponEditType === "clone") {
        handlePublishClickOnClone(setOpenPublishConfirmModal,setModalMessage);
    } else {
        await handlePublishClick();
    }
}